/**
 * PINSEEKER — STEALTH SYSTEMS v3.0
 * File: assets/ps-main.js
 * Codename: OPERATION: PIN SEEKER
 * Status: [SYSTEM: GO]
 *
 * Modules:
 *  1. Add-to-Cart State Machine (ATC)
 *  2. Live Technical Ticker
 *  3. Scroll Animation (IntersectionObserver)
 *  4. Radar Sweep Cursor Enhancement
 */

/* ==========================================================================
   1. ADD-TO-CART STATE MACHINE (ATC)
   Button transitions: ADD TO BAG → LOCKING TARGET... → TARGET ACQUIRED → reset
   ========================================================================== */

function initPSATC() {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-ps-atc]');
    if (!btn) return;

    const variantId  = btn.dataset.variantId;
    const originalText = btn.dataset.originalText || btn.textContent.trim();

    // Store original text on first click
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = originalText;
    }

    // Guard: do nothing if already mid-animation
    if (btn.disabled) return;

    // ── STATE 1: LOCKING TARGET ──────────────────────────────────────────────
    btn.textContent = 'LOCKING TARGET...';
    btn.disabled    = true;
    btn.classList.remove('ps-btn--acquired');
    btn.classList.add('ps-btn--locking');

    // Shopify AJAX cart add
    fetch(window.Shopify ? '/cart/add.js' : '#', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => {
      if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
      return response.json();
    })
    .then(() => {
      // ── STATE 2: TARGET ACQUIRED ───────────────────────────────────────────
      btn.textContent = 'TARGET ACQUIRED';
      btn.classList.remove('ps-btn--locking');
      btn.classList.add('ps-btn--acquired');

      // Dispatch cart update event for Horizon's native cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      // ── STATE 3: RESET after 2.5s ──────────────────────────────────────────
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled    = false;
        btn.classList.remove('ps-btn--acquired');
      }, 2500);
    })
    .catch(() => {
      // ── ABORT STATE ────────────────────────────────────────────────────────
      btn.textContent = originalText;
      btn.disabled    = false;
      btn.classList.remove('ps-btn--locking', 'ps-btn--acquired');
    });
  });
}

document.addEventListener('DOMContentLoaded', initPSATC);

/* ==========================================================================
   3. LIVE TECHNICAL TICKER
   Scrolling DM Mono status strip — duplicated for seamless loop
   ========================================================================== */

const PS_TICKER_ITEMS = [
  'SHIPPING: CLEARED',
  'STATUS: ZERO DEVIATION',
  'MATERIALS: 400GSM CERTIFIED',
  'MAGNETS: NEODYMIUM GRADE',
  'NEXT DROP: INCOMING',
  'UK DELIVERY: ACTIVE',
  'PRINT: DYE-SUBLIMATION — BOTH SIDES',
  'CENTRE-SLIT: OPERATIONAL',
  'PRECISION ON APPROACH'
];

function initPSTicker() {
  const tickers = document.querySelectorAll('[data-ps-ticker]');
  if (!tickers.length) return;

  tickers.forEach(ticker => {
    const track = ticker.querySelector('.ps-ticker__track');
    if (!track) return;

    // Build item HTML
    const itemsHTML = PS_TICKER_ITEMS
      .map(item => `<span class="ps-ticker__item">${item}</span>`)
      .join('');

    // Duplicate for seamless infinite scroll
    track.innerHTML = itemsHTML + itemsHTML;
  });
}

document.addEventListener('DOMContentLoaded', initPSTicker);

/* ==========================================================================
   4. SCROLL ANIMATIONS — IntersectionObserver
   Elements with .ps-animate-up fade up when entering viewport
   ========================================================================== */

function initPSScrollAnimations() {
  const elements = document.querySelectorAll('.ps-animate-up');
  if (!elements.length) return;

  // Reduced motion: skip animations if user has OS preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    elements.forEach(el => el.classList.add('ps-animate--visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ps-animate--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold:  0.12,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  elements.forEach(el => observer.observe(el));
}

document.addEventListener('DOMContentLoaded', initPSScrollAnimations);

/* ==========================================================================
   5. STATUS PILL DYNAMIC CONTENT
   Injects correct copy for inventory status pills
   ========================================================================== */

function initPSStatusPills() {
  // Auto-update inventory pills if Shopify availability data is present
  document.querySelectorAll('[data-ps-stock-pill]').forEach(pill => {
    const available = pill.dataset.available;
    if (available === 'true') {
      pill.textContent = '[IN STOCK]';
      pill.classList.add('ps-pill--go');
    } else if (available === 'false') {
      pill.textContent = '[MISSION ABORTED]';
      pill.classList.add('ps-pill--aborted');
      pill.classList.remove('ps-pill--go');
    }
  });
}

document.addEventListener('DOMContentLoaded', initPSStatusPills);

/* ==========================================================================
   6. UTILITY: CROSSHAIR CURSOR ENFORCEMENT
   Ensures product cards use the crosshair cursor in all browsers
   ========================================================================== */

function initPSCrosshair() {
  // Product cards and collection cards — set in CSS, this JS handles
  // dynamically-injected cards (e.g. from section rendering)
  document.querySelectorAll('.ps-product-card, .ps-collection-card').forEach(card => {
    card.style.cursor = 'crosshair';
  });

  // Re-run on dynamic content changes
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.ps-product-card:not([data-cursor-set]), .ps-collection-card:not([data-cursor-set])').forEach(card => {
      card.style.cursor = 'crosshair';
      card.setAttribute('data-cursor-set', 'true');
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', initPSCrosshair);

/* ==========================================================================
   END — PINSEEKER ps-main.js
   MISSION: COMPLETE // ALL SYSTEMS: GO
   ========================================================================== */
